export const buildHostWithSlug = (slug: string, hostPath: string): string => {
  const normalizedSlug = slug.trim();
  const normalizedHostPath = hostPath.trim();

  if (!normalizedSlug || normalizedHostPath.startsWith(normalizedSlug)) {
    return normalizedHostPath;
  }

  return `${normalizedSlug}.${normalizedHostPath}`;
};
